/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonPersonidResumeeExamTries200,
  GetApiV1PersonPersonidResumeeExamTries400,
  GetApiV1PersonPersonidResumeeExamTries401,
  GetApiV1PersonPersonidResumeeExamTries500,
  GetApiV1PersonPersonidResumeeExamTriesPathParams,
  GetApiV1PersonPersonidResumeeExamTriesQueryParams,
  GetApiV1PersonPersonidResumeeExamTriesQueryResponse,
} from "../../types/personResumeeController/GetApiV1PersonPersonidResumeeExamTries.ts";
import { studentCourseExamTryViewModelSchema } from "../studentCourseExamTryViewModelSchema.ts";

export const getApiV1PersonPersonidResumeeExamTriesPathParamsSchema = z.object({
  personId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonPersonidResumeeExamTriesPathParams>;

export const getApiV1PersonPersonidResumeeExamTriesQueryParamsSchema = z
  .object({
    examReferenceIds: z.optional(z.array(z.coerce.number().int())),
  })
  .optional() as unknown as ToZod<GetApiV1PersonPersonidResumeeExamTriesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonPersonidResumeeExamTries200Schema = z.array(
  z.lazy(() => studentCourseExamTryViewModelSchema),
) as unknown as ToZod<GetApiV1PersonPersonidResumeeExamTries200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1PersonPersonidResumeeExamTries400Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeExamTries400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonPersonidResumeeExamTries401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeExamTries401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonPersonidResumeeExamTries500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeExamTries500>;

export const getApiV1PersonPersonidResumeeExamTriesQueryResponseSchema = z.lazy(
  () => getApiV1PersonPersonidResumeeExamTries200Schema,
) as unknown as ToZod<GetApiV1PersonPersonidResumeeExamTriesQueryResponse>;
